<template>
    <div id="map-comp"></div>
</template>

<script setup>
import { onMounted, shallowRef } from 'vue';
import { useMapStore } from '@/mapStore';
import L from 'leaflet';
import 'leaflet-polylinedecorator';

const map = shallowRef(null);
const mapStore = useMapStore();

onMounted(() => {
    // Rotation code, adapted from:
    // https://github.com/bbecquet/Leaflet.RotatedMarker/blob/master/leaflet.rotatedMarker.js
    //

    // add support for rotating markers
    (function () {
        // Save original method before overwriting it below.
        const _setPosOriginal = L.Marker.prototype._setPos

        L.Marker.addInitHook(function () {
            const anchor = this.options.icon.options.iconAnchor
            this.options.rotationOrigin = anchor ? `${anchor[0]}px ${anchor[1]}px` : 'center center'
        })

        L.Marker.include({
            // _setPos is alled when update() is called, e.g. on setLatLng()
            _setPos: function (pos) {
                _setPosOriginal.call(this, pos)
                if (this.options.rotation) this._rotate()
            },
            _rotate: function () {
                this._icon.style[`${L.DomUtil.TRANSFORM}Origin`] = this.options.rotationOrigin
                this._icon.style[L.DomUtil.TRANSFORM] += ` rotate(${this.options.rotation}deg)`
            }
        })
    })()

    map.value = L.map('map-comp', { preferCanvas: true }).setView([51.505, -0.09], 13);


    const leafletCSS = document.createElement('link');
    leafletCSS.rel = 'stylesheet';
    leafletCSS.href = 'https://unpkg.com/leaflet/dist/leaflet.css';
    document.head.appendChild(leafletCSS);


    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map.value);

    mapStore.setMap(map.value);
});

</script>

<style>
#map-comp {
    height: 100%;
    width: 100%;
    overflow: hidden;
}
</style>